module.exports = __webpack_public_path__ + "assets/ic_comment.bc6413d8.svg";